import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import Seo from "../components/Seo";

export default function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products").then(r => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="products-page" className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 md:py-10">
      <Seo
        title="Shop the towels"
        description="Three original monotype yoga towels — Sure, April and Occult — by Toronto artist Kelsey-Lynn. Anti-slip microfibre. Designed in Canada. Free shipping on 2+."
        path="/products"
      />
      <div className="text-center mb-6 md:mb-8">
        <div className="label-eyebrow mb-2">Your towel</div>
        <h1 className="font-serif-display text-3xl md:text-5xl leading-none mb-3">A space to create.</h1>
        <p className="max-w-2xl mx-auto text-sm opacity-70 leading-relaxed">
          Three original monotypes by Toronto artist{" "}
          <a href="/artist" className="underline underline-offset-4" style={{ color: "var(--kaiya-primary)" }}>Kelsey-Lynn</a>.
          A portion of every purchase directly supports the artist.
        </p>
      </div>

      {loading ? (
        <div className="opacity-60 text-center py-8">Loading…</div>
      ) : products.length === 0 ? (
        <div className="opacity-60 text-center py-8">The collection restocks soon.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} compact />)}
        </div>
      )}
    </div>
  );
}
